import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export const getRouteName = (path) => {
  return path ? path.replace(currentStoreView().storeCode + '-', '') : 'undefined-route'
}
